/* import React from 'react'; */

import Grid from './Grid';

import './styles/style.scss';

export default Grid;

export { default as Container } from './Container';
export { default as GridCol } from './GridCol';



// WEBPACK FOOTER //
// ./src/components/Grid/index.js